import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { etapeSuivante } from 'store/etapes/etapesActions';
import { Bouton, Row, Col, LoaderMi } from '@design-system-etat/dsfr-react';
import InformationAdresse from 'components/adresse/InformationsAdresse';
import InformationsPersonnelles from 'components/informationsPersonnelles/InformationsPersonnelles';
import BoutonTelechargementFichier from 'components/BoutonTelechargementFichier/BoutonTelechargementFichier';
import { reinitialiseAPI, getAPI } from 'store/apiReducer';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_RECUPERER_INFORMATIONS_PERSONNELLES,
    CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
} from 'constants/apiUrls.constants';
import RoutesMesDemarches from '../../routes';
import { getPath } from '../../../../../utils/router';

const CreerTitreDetentionEtape1 = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const { isLoading, data, message, erreur } = useSelector(
        (state) => state.monCompte.recupererInformationsPersonnelles,
    );

    const recuperationInformations = () => {
        dispatch(
            getAPI(
                usagerClientReducer,
                API_RECUPERER_INFORMATIONS_PERSONNELLES,
                CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES,
            ),
        );
        return () => {
            dispatch(reinitialiseAPI(CONTEXT_API_RECUPERER_INFORMATIONS_PERSONNELLES));
        };
    };

    useEffect(() => {
        recuperationInformations();
    }, []);

    if (isLoading) {
        return (
            <div className="loader-full-screen">
                <LoaderMi taille="md" />
            </div>
        );
    }
    if (erreur) {
        return (
            <div className="margin-top-md margin-bottom-md">
                <p>{message}</p>
            </div>
        );
    }

    if (isLoading === false && !data.personnePhysique) {
        return (
            <div className="margin-top-md margin-bottom-md">
                <p>Une erreur s&apos;est produite !</p>
            </div>
        );
    }

    let fichier = null;
    if (data?.personnePhysique?.adressePrincipale?.justificatifsDomicile) {
        [fichier] = data.personnePhysique.adressePrincipale.justificatifsDomicile.fichiers;
    }

    return (
        <div>
            <Row goutierre>
                <Col lg={6}>
                    <h3 className="margin-top-xs font-size-lg">Identité</h3>
                    {data && data.personnePhysique && (
                        <InformationsPersonnelles
                            dataInformationsPersonnelles={data.personnePhysique}
                        />
                    )}
                </Col>
                <Col lg={6}>
                    <h3 className="margin-top-xs font-size-lg">Résidence principale</h3>
                    {data && data.personnePhysique && data.personnePhysique.adressePrincipale && (
                        <InformationAdresse
                            adresse={data.personnePhysique.adressePrincipale}
                            afficherBoutonAction={false}
                        />
                    )}
                    <div className="margin-top-md">
                        {fichier && (
                            <BoutonTelechargementFichier
                                libelle={fichier.filename}
                                uuidFichier={fichier.uuid}
                                key={fichier.uuid}
                            />
                        )}
                    </div>
                </Col>
            </Row>
            <div className="margin-top-md" />
            <Row goutierre>
                <Col lg={12}>
                    <i>
                        Si vous constatez des erreurs concernant les informations sur votre identité
                        ou votre adresse de résidence principale, merci de les modifier depuis votre
                        gestion de compte en cliquant sur le bouton "Mon profil"
                    </i>
                </Col>
            </Row>
            <div className="margin-top-md" />
            <Row goutierre>
                <Col lg={6}>
                    <Bouton
                        name="Annuler"
                        label="Annuler"
                        onClick={() => history.push(getPath(RoutesMesDemarches))}
                        niveau="secondaire"
                    />
                </Col>
                <Col lg={6}>
                    <div className="text-right">
                        <Bouton
                            name="EtapeSuivante"
                            label="Étape Suivante"
                            niveau="primaire"
                            onClick={() => dispatch(etapeSuivante())}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    );
};

export default CreerTitreDetentionEtape1;
